var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('Breadcrumb',{attrs:{"title":'Google Authenticator'}}),_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8 col-lg-8 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('GoogleAuth')],1)])]),_c('Sidebar')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }